<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Stock In</h5>
                    <div class="d-flex align-items-center">
                        <div class="col-md-"><select v-model="params.divisi_id" class="form-select btn-sm">
                                <option value="">All Divisi</option>
                                <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">{{
                                    (option as any).name }}</option>
                            </select></div>
                        <button class="btn btn-sm btn-primary ms-1 me-1" @click="isform = !isform; data = null"
                            :disabled="loading"><i class="fa fa-solid fa-plus"></i>
                            Create</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <DataTable :headers="headers" :items="warehouseStockin" :loading="loading" :total="total"
                    :params="params" @update:params="updateParams">
                    <template #item.date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        formatDateTime(item.date) }}</template>
                    <template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.ID }}</template>
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning ms-1 me-1" @click="isView = true; data = item">
                            <i class="fa fa-solid fa-eye"></i>
                        </button>
                        <button class="btn btn-sm btn-warning ms-1 me-1" @click="isform = !isform; data = item">
                            <i class="fa fa-solid fa-pencil"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
    <Form title="Create Stock In" v-if="isform" :data="data" @on-closed="isform = false; fetchStockin()" />
    <View title="View Stock In" v-if="isView" :data="data" @on-closed="isView = false" />
</template>
<script lang="ts" setup>
import { ref, watch, reactive, onMounted, defineAsyncComponent } from 'vue'
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
const Form = defineAsyncComponent(() => import("./Form.vue"))
const View = defineAsyncComponent(() => import("./View.vue"))
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import * as master from '@/api/services/MasterRequest'
import * as warehouse from '@/api/services/WarehouseRequest'
import * as ExcelJS from 'exceljs'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const isform = ref(false)
const isView = ref(false)
const data = ref<any>(null)
const divisiOptions = ref<{ ID: any }[]>([])

const headers = [
    { text: 'Divisi', value: 'divisi_name' },
    { text: 'Code', value: 'code' },
    { text: 'Date', value: 'date' },
    { text: 'PIC Name', value: 'pic_name' },
    { text: 'PIC No Telp', value: 'pic_notelp' },
    { text: 'PIC Remark', value: 'pic_remark' },
    { text: 'Description', value: 'description' },
    { text: 'Createsd By', value: 'created_by' },
    { text: '#Act', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const warehouseStockin = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    divisi_id: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.ID,

})


const fetchStockin = async () => {
    data.value = {}
    loading.value = true
    try {
        // Simulate API delay
        await warehouse.postRequest("/stock-in/list", params).then((response) => {
            warehouseStockin.value = response.data;
            total.value = response.total
        });

        loading.value = false
    } catch (error) {
        toast.error('Failed to fetch warehouse stock')
        loading.value = false
    }
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchStockin()
}

onMounted(() => {
    divisiOptions.value = session.divisionOptions()

})

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

function totalSo(items: any[]) {
    return separator(items.length);
}

function totalProduk(items: any[]) {
    return separator(items.reduce((total, item) => total + item.qty_total, 0));
}

function separator(value: number) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const deleteData = async (id: number) => {
    if (!confirm('Are you sure you want to delete this Stock?')) return

    loading.value = true
    try {
        await warehouse.postRequest("/stock-in/delete", { ID: id }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Return deleted successfully');
                fetchStockin();
            } else {
                toast.error('Failed to delete Stockin');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to delete Stockin');
    } finally {
        loading.value = false
    }
}


</script>
